import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

export const UserPageHeaderText: any = styled(Box)`
    min-height: 200px;
    position: relative;
    left: 15px;
    font-weight: 500;
    font-style: normal;
    font-size: 36px;
    font-family: "Nexa Light";
    color: #ffffff;
    margin: 0 auto 0 auto;
    width: 100%;
    max-width: 1140px;

    @media only screen and (max-width: ${breakpointTheme.breakpoints.values.md + "px"}) {
        height: 200px;
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.md + "px"}) and (max-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        height: 200px;
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        height: 300px;
    }

    .quickquote {
        position: absolute;
        bottom: 40px;
        line-height: 52.8px;
        // background-color: green;
    }
`;
